import { Icon } from '@chakra-ui/react';

export const ArrowLeftIcon = (props: any) => (
  <Icon aria-label="arrow left icon" {...props}>
    <path
      d="M8.41129061,6 L10,7.48679212 L6.245,11 L22,11 L22,13 L6.245,13 L10,16.5132079 L8.41129061,18 L2,12 L8.41129061,6 Z"
      fill="currentColor"
    />
  </Icon>
);
